<template>
    <div class="row left-content">
        <b-card
            v-if="subscription"
            :title="subscription.project_name + ' subscription data'"
            :sub-title="'Expiration date: ' + formatedDate(subscription.expiration_date)"
        >
            <table class="table table-bordered table-striped mt-4">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Cost</th>
                    <th>Created At</th>
                    <th>Payment info</th>
                    <th>Access Fee</th>
                    <th>Number of checks</th>
                    <th>Transaction sum</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="billing in billings" :key="billing.id">
                    <td>{{ billing.id }}</td>
                    <td>${{ billing.cost }}</td>
                    <td>{{ formatedDate(billing.created_at) }}</td>
                    <td>
                        <b-badge variant="danger" v-if="!billing.payment_status">Not paid</b-badge>
                        <ul v-else>
                            <li><b>Paid At: </b>{{ formatedDate(billing.paid_at) }}</li>
                            <li><b>Payment ID: </b>{{ billing.payment_system_id }}</li>
                            <li><b>Status: </b> <b-badge variant="primary">{{ billing.payment_status }}</b-badge></li>
                        </ul>
                    </td>
                    <td>${{ billing.access_fee }}</td>
                    <td>{{ billing.number_of_checks }}</td>
                    <td>${{ billing.transaction_sum }}</td>
                </tr>
                </tbody>
            </table>
        </b-card>

    </div>
</template>

<script>
export default {
    name: "List",
    props: [],
    data() {
        return {
            billings: [],
            subscription: null
        }
    },
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        }
    },
    mounted() {
        window.axios.get('/admin/subscription/billings-list')
            .then(response => {
                    this.billings = response.data.billings;
                    this.subscription = response.data.subscription;
                }
            );
    }
}
</script>